import { Link } from '@reach/router';
import React from 'react';
import logo from '../../images/mark-blue.svg';

const AdminNav: React.FC = () => (
  <div className="flex-none pa3 flex justify-between items-center">
    <Link to="/" className="flex items-center">
      <img src={logo} alt="Quala" style={{ width: 35, height: 35 }} />
    </Link>

    <div>
      <Link to="/admin" className="dib br2 ph3 pv3 f6 blue hover-navy">
        Invite List
      </Link>
      <Link to="/admin/invite" className="dib pv3 white f6 blue hover-navy">
        New Invite
      </Link>
    </div>
  </div>
);

export default AdminNav;
